module.exports = __webpack_public_path__ + "static/media/gif4.090a9a6e.gif";